<template>
  <div class="calendar-container">
    <div v-for="d in computed_events" :key="d.day"
         class="calendar-header"
         :class="{'calendar-theme-1': !(d.weekday&1), 'calendar-theme-2': d.weekday&1, 'calendar-theme-3': d.weekday===7}"
    >{{d.weekdayLabel}} {{d.day}}</div>
    <div v-for="d in computed_events" :key="d.day"
         class="calendar-cell"
         :class="{'calendar-theme-1': !(d.weekday&1), 'calendar-theme-2': d.weekday&1, 'calendar-theme-3': d.weekday===7}"
    >
      <div v-for="e in d.events" class="event">
        <p class="event-time">{{e.starttime}}-{{e.endtime}}</p>
        <p class="event-title" v-html="e.title"/>
        <p class="event-body" v-html="e.body"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    events: {
      type: Object,
      default: [
        {
          date: "2022/01/03",
          weekday: 1,
          events: []
        },
        {
          date: "2022/01/04",
          weekday: 2,
          events: []
        },
        {
          date: "2022/01/05",
          weekday: 3,
          events: []
        },
        {
          date: "2022/01/06",
          weekday: 4,
          events: []
        },
        {
          date: "2022/01/07",
          weekday: 5,
          events: []
        },
        {
          date: "2022/01/08",
          weekday: 6,
          events: []
        },
        {
          date: "2022/01/09",
          weekday: 7,
          events: []
        }
      ]
    },
    theme: {
      type: Object,
      default: {
        0: ['#ff8B46', '#eb5307', '#db5709', '#222'],
        1: ['#3566db', '#0d40b8', '#00298c', '#eee'],
        2: ['#bdbdbd', '#949494', '#666666', '#222'],
        header: '#fff',
        grid: '#fff',
      }
    },
    scrollDelayTop: {
      type: Number,
      default: 4000
    },
    scrollDelayBottom: {
      type: Number,
      default: 4000
    },
    scrollingTime: { /*scollingTime is multiplied by the height in pixels when scrolling so that the actual speed is adapted to the length of the div*/
      type: Number,
      default: 50
    }
  },
  computed:{
    computed_events(){
      var res = [...this.events];
      res.forEach((item) => {
        item.weekdayLabel = this.getWeekdayLabel(item.weekday);
        item.day = parseInt(item.date.slice(-2));
      });
      return res;
    }
  },
  methods: {
    getWeekdayLabel(day) {
      switch (day) {
        case 1:
          return 'LUN'
        case 2:
          return 'MAR'
        case 3:
          return 'MER'
        case 4:
          return 'GIO'
        case 5:
          return 'VEN'
        case 6:
          return 'SAB'
        case 7:
          return 'DOM'
        default:
          return '-'
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      //wait scrollDelayTop ms --> scoll to bottom in scrollHeight * scrollingTime ms -->wait scrollDelayBottom ms --> repeat
      const autoScrollAnimation = (element) => {
        var elementScrollHeight = element.scrollHeight - $(element).height();
        //animation
        $(element).animate({
          scrollTop: elementScrollHeight, //scrollTop property
        }, elementScrollHeight * this.scrollingTime, "linear", () => { /*callback*/
          setTimeout(() => {
            //scroll back to the top
            $(element).scrollTop(0);
            setTimeout(() => {
              autoScrollAnimation(element) //do it again
            }, this.scrollDelayTop); //delay top
          }, this.scrollDelayBottom); //delay bottom
        });
      }

      setTimeout(() => {
        $(".calendar-cell").each(function (index) {
          autoScrollAnimation(this);
        });
        /*if the delay is too low the first time the animation won't start (bug)*/
      }, Math.min(this.scrollDelayTop, 2000)) //delay top
    })
  },
  name: "EventsCalendar"
}
</script>

<style scoped>
.calendar-container{
  width: 100%;
  height: 100%;
  display: grid;
  border-top: 4px solid black;
  grid-template-columns: repeat(v-bind("events.length"), 1fr);
  grid-template-rows: 35px minmax(0, 1fr);
  gap: 5px;
  background-color: v-bind(theme['grid']);
}
.calendar-header{
  font-size: 25px;
  color: v-bind(theme['header']);
  text-align: center;
  vertical-align: middle;
}
.calendar-cell{
  overflow: hidden;
  padding: 8px;
  font-size: 25px;
}
.calendar-theme-1.calendar-cell{
  background-color: v-bind(theme[0][0]);
}
.calendar-theme-2.calendar-cell{
  background-color: v-bind(theme[1][0]);
}
.calendar-theme-3.calendar-cell{
  background-color: v-bind(theme[2][0]);
}
.calendar-theme-1.calendar-header{
  background-color: v-bind(theme[0][2]);
}
.calendar-theme-2.calendar-header{
  background-color: v-bind(theme[1][2]);
}
.calendar-theme-3.calendar-header{
  background-color: v-bind(theme[2][2]);
}
.calendar-theme-1 > .event{
  background-color: v-bind(theme[0][1]);
  color: v-bind(theme[0][3]);
}
.calendar-theme-2 > .event{
  background-color: v-bind(theme[1][1]);
  color: v-bind(theme[1][3]);
}
.calendar-theme-3 > .event{
  background-color: v-bind(theme[2][1]);
  color: v-bind(theme[2][3]);
}
.event{
  margin-bottom: 8px;
  padding: 5px 5px 15px;
  border-radius: 10px;
}
p{
  margin: 10px 0;
}
.event-time{
  margin: 0;
  text-align: right;
  font-size: 15px;
}
</style>